import "liquid-ajax-cart";
import "./gamification-sitewide";
import "./add-to-card-plp";
import "./product/product-atc-sticky";
import "./add-to-card-plp";
import "./product/estimate-day";
import "./product/size-guide";
//import "./product/estimate-day";

document.addEventListener('DOMContentLoaded', function () {
  var btn_toggle_cart = document.querySelector("#cart-icon");
  btn_toggle_cart.addEventListener('click', function () {
    var cart = document.body;
    cart.classList.add('upcartPopupShow');
  });
});
import "./sidecart";
import "./ab-test-general";